import { createRef } from 'react';

export const CANVAS_REF = createRef<HTMLDivElement>();

export const CANVAS_WRAP_REF = createRef<HTMLElement>();

export const LAYER_LIST_REF = createRef<HTMLElement>();
